import { CountryCodes } from '@audibene/react-components-lib'
import { SalesStatus } from '@audibene/ta.utils-opportunity'
import { sortBy } from 'remeda'
import { Opportunity } from 'types'

/**
 * Possibly still error-prone
 * more robust than only using createdAt or updatedAt date to determine actual latest opportunity
 * best option is to add a way to flag the opportunity as the active/latest one in data.
 * */

type SortRule = 'asc' | 'desc'

/**
 * If opportunity is from CH or DE, we consider it the latest if it is current.
 * If it is from any other country (US), we consider it the latest if it has a trial end date or if the sales status is WON.
 * @param opportunity
 * @returns
 */
const findMostLikelyLatestOpportunity = (opportunity: Opportunity) =>
  [CountryCodes.CH, CountryCodes.DE].includes(opportunity.country as CountryCodes)
    ? Boolean(opportunity.isCurrent)
    : Boolean(opportunity.trialEndDate) || Boolean(opportunity.salesStatus.status === SalesStatus.WON)

const toOriginalSort = (opportunities: Opportunity[], originalSort: SortRule = 'asc') =>
  sortBy(opportunities, [(opportunity: Opportunity) => new Date(opportunity.trialEndDate || 0), originalSort])

const findLatestOpportunities = (
  opportunities: Opportunity[],
  currentOpportunity: Opportunity | undefined,
  isNeoEnabled: boolean,
  shouldFilter = true,
  originalSort?: SortRule
) => {
  if (isNeoEnabled && currentOpportunity) {
    return currentOpportunity ? [currentOpportunity] : []
  }

  const sorted = sortBy(opportunities, [(opportunity: Opportunity) => new Date(opportunity.updatedAt), 'desc'])

  if (!shouldFilter) return toOriginalSort(sorted, originalSort)

  const output = sorted.filter(findMostLikelyLatestOpportunity)

  return output.length ? output : sorted // We need to not change the original sorting
}

export { findLatestOpportunities }
